import { IconFont } from '@/components/IconFont'
import { deleteTask, getSubTasks } from '@/services/task/task'
import { useRequest } from 'ahooks'
import { Button, Row } from 'antd'
import { memo, useState } from 'react'
import { Link } from 'react-router-dom'
import TaskAssign from '../components/TaskField/TaskAssign'
import TaskName from '../components/TaskField/TaskName'
import styles from './index.module.less'

const SubtaskList = memo((props: any) => {
  const { task, members } = props
  const [subtasks, setSubtasks] = useState<any[]>([])
  const { refresh } = useRequest(() => getSubTasks(task.id), { onSuccess: (data) => setSubtasks(data) })

  const handleAddSubTask = () => {
    setSubtasks((origin) => [...origin, { id: -1, parentId: task.id }])
  }

  const handleAddSuccess = (data) => {
    setSubtasks((origin) => {
      const tasks = origin.filter((item) => item.id !== -1)
      return [...tasks, data]
    })
  }

  const handleAddCancel = () => {
    setSubtasks((origin) => origin.filter((item) => item.id !== -1))
  }

  const handleUpdateTask = (data) => {
    setSubtasks((origin) => origin.map((item) => (item.id === data.id ? data : item)))
  }

  return (
    <div>
      <Row justify={'space-between'}>
        <h5>Subtask</h5>

        <Button type='text' size={'small'} onClick={handleAddSubTask}>
          <IconFont type='icon-add' />
        </Button>
      </Row>

      {!!subtasks.length && (
        <div className={styles.taskList}>
          {subtasks.map((subtask) => (
            <div key={subtask.id} className={styles.listItem}>
              <div className={styles.itemNum}>
                <span>#{subtask.num}</span>
              </div>
              <div className={styles.itemName}>
                {subtask.id === -1 ? (
                  <TaskName task={subtask} editing={true} onSuccess={handleAddSuccess} onCancel={handleAddCancel} />
                ) : (
                  <Link to={`../${subtask.id}`} className={'link'}>
                    {subtask.name}
                  </Link>
                )}
              </div>
              <div className={styles.itemAssign}>
                <TaskAssign members={members} task={subtask} onSuccess={handleUpdateTask} />
              </div>
              <div className={styles.itemAction}>
                <Button
                  type='text'
                  size={'small'}
                  onClick={async () => {
                    await deleteTask(subtask.id)
                    refresh()
                  }}
                >
                  <IconFont type='icon-delete' />
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
})

export default SubtaskList
